// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"312":"43204670","386":"857b5e64","544":"a74b58d5","568":"2d4d7359","672":"cfe7974d"}[chunkId] + ".chunk.css";
};